<div id="logoContent">
  <div id="logoPreview" class="al_live_preview"
    [ngClass]="tabIndex === 4 || tabIndex === 5 || tabIndex === 6 ? 'preview_padding' : ''">
    <iposcen-content-live-preview
      *ngIf="(presentPage === 'asset-library' && tabIndex === 3 && !deviceStoreLogoOtherData)" [sidenav]="pageType"
      [defaultLogo]="defaultStoreLogos" [enableAIIPOSPreview]="enableAIIPOS"
      [logoPresentPage]="presentPage"></iposcen-content-live-preview>
    <!-- Live preview - temporarly image -->
    <iposcen-live-preview [sidenav]="pageType"
      *ngIf="tabIndex === 4 || tabIndex === 5 || tabIndex === 6 "></iposcen-live-preview>
    <!-- Layout of preview -->
    <div id="layout" class="preview_layout" *ngIf="tabIndex === 4 || tabIndex === 5 || tabIndex === 6">
      <div *ngIf="showPreviewLayout">
        <div id="LCG1" class="card">
          <img
            src="{{LCGlayout === 1 ?  'assets/images/prev_layout_selected_1.svg': 'assets/images/prev_layout_1.svg'}}"
            alt="layout 1" (click)="setLayout(1)" class="cursor-pointer" />
        </div>
        <div id="LCG2" class="card">
          <img
            src="{{LCGlayout === 2 ?  'assets/images/prev_layout_selected_2.svg': 'assets/images/prev_layout_2.svg'}}"
            alt="layout 2" (click)="setLayout(2)" class="cursor-pointer" />
        </div>
        <div id="LCG3" class="card">
          <img
            src="{{LCGlayout === 3 ?  'assets/images/prev_layout_selected_3.svg': 'assets/images/prev_layout_3.svg'}}"
            alt="layout 3" (click)="setLayout(3)" class="cursor-pointer" />
        </div>
      </div>
    </div>
  </div>
  <section class="main_section al_storelogo">
    <!-- Navtabs -->
    <ul *ngIf="tabIndex !== 3 && tabIndex !== 4 && tabIndex !== 5 && tabIndex !== 6 && !deviceStoreLogoOtherData"
      class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link gtmAssetLibraryLogoContentStoreLogo" data-toggle="tab" (click)="setIndex(0)"
          [ngClass]="{'active': tabIndex === 0}">
          <span i18n="@@logo-content.header.store-logos">STORE LOGOS</span>
        </a>
      </li>
      <li class="nav-item" *ngIf="!this.setIposliteEnabled">
        <a class="nav-link gtmAssetLibraryLogoContentLogoContentGroups" data-toggle="tab"
          *ngIf="presentPage !== profile_page" (click)="setIndex(1)" [ngClass]="{'active': tabIndex === 1}">
          <span i18n="@@logo-content.header.logo-content-groups">LOGO CONTENT GROUPS</span>
        </a>
        <a class="nav-link gtmAssetLibraryLogoContentLogoContentGroups" data-toggle="tab"
          *ngIf="presentPage === profile_page && defaultStoreLogos?.length === 0" (click)="setIndex(0)"
          [ngClass]="defaultStoreLogos?.length === 0?'tabdisabled':''">
          <span i18n="@@logo-content.header.logo-content-groups" ngbTooltip={{selectLogoContentTooltip}} placement="top"
            container="body" tooltipClass="tooltipnowrap">LOGO CONTENT GROUPS</span>
        </a>
        <a class="nav-link gtmAssetLibraryLogoContentLogoContentGroups" data-toggle="tab"
          *ngIf="presentPage === profile_page && defaultStoreLogos?.length > 0" (click)="setIndex(1)"
          [ngClass]="{'active': tabIndex === 1}">
          <span i18n="@@logo-content.header.logo-content-groups">LOGO CONTENT GROUPS</span>
        </a>
      </li>
      <li class="nav-item" *ngIf="!this.setIposliteEnabled">
        <a *ngIf="presentPage === profile_page && isDWPEnabled" class="nav-link gtmAssetLibraryLogoContentStoreLogo"
          data-toggle="tab" (click)="setIndex(2)" [ngClass]="{'active': tabIndex === 2}">
          <span i18n="@@logo-content.device-wall-paper.heading">DEVICE WALLPAPER</span>
        </a>
      </li>
    </ul>
    <ul *ngIf="(tabIndex === 3 || tabIndex === 4 || tabIndex === 5 || tabIndex === 6)" class="nav nav-tabs"
      role="tablist">
      <li class="nav-item">
        <a class="nav-link gtmAssetLibraryLogoContentTitle" data-toggle="tab" [ngClass]="{'active': tabIndex === 3}"
          (click)="navigate()"><span placement="top" container='body'
            ngbTooltip="{{editCheck?showLogContentName + details:newLogoContentTitle}}">{{editCheck?
            tabTrimString(showLogContentName) : tabTrimString(newLogoContentTitle) }}</span></a>
      </li>
      <li class="nav-item" *ngIf="pages && pages.page1">
        <a class="nav-link gtmAssetLibraryLogoContentPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
          (click)="clickable?setIndex(4):false"><span i18n="@@global.tab-nav.page1">PAGE 1</span></a>

        <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
        <!-- <a class="nav-link gtmAssetLibraryLogoContentPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
          (click)="clickable?setIndex(4):false">
          <div class="page_container">
            <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page1">PAGE 1</span>&nbsp;</div>
            <div class="delete_page" *ngIf="pagelen > 1" (click)="clickable?openPopup(deletePageModal,0):false"></div>
          </div>
        </a> -->
      </li>
      <li class="nav-item" *ngIf="pages && pages.page2">
        <a class="nav-link gtmAssetLibraryLogoContentPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 5}"
          (click)="clickable?setIndex(5):false"><span i18n="@@global.tab-nav.page2">PAGE 2</span></a>

        <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
        <!-- <a class="nav-link gtmAssetLibraryLogoContentPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 5}"
          (click)="clickable?setIndex(5):false">
          <div class="page_container">
            <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page2">PAGE 2</span>&nbsp;</div>
            <div class="delete_page" (click)="clickable?openPopup(deletePageModal,1):false"></div>
          </div>
        </a> -->
      </li>
      <li class="nav-item" *ngIf="pages && pages.page3">
        <a class="nav-link gtmAssetLibraryLogoContentPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 6}"
          (click)="clickable?setIndex(6):false"><span i18n="@@global.tab-nav.page3">PAGE 3</span></a>

        <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
        <!-- <a class="nav-link gtmAssetLibraryLogoContentPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 6}"
          (click)="clickable?setIndex(6):false">
          <div class="page_container">
            <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page3">PAGE 3</span>&nbsp;</div>
            <div class="delete_page" (click)="clickable?openPopup(deletePageModal,2):false"></div>
          </div>
        </a> -->
      </li>
      <li class="nav-item" *ngIf="clickable && !checkPages()">
        <a class="nav-link gtmAssetLibraryLogoContentAddPage" data-toggle="tab" (click)="addPage()">
          <img src="assets/images/add_black_square_outline.svg" alt="exit without changes" />
        </a>
      </li>
      <li class="nav-item exit_preview" *ngIf="pages && pages.page1">
        <a class="nav-link gtmAssetLibraryLogoContentClose" (click)="close();resetPage()">
          <img src="assets/images/exit_icon.svg" alt="exit without changes" />
        </a>
      </li>
    </ul>


    <!-- Device Wallpaper tab -->
    <div *ngIf="presentPage === profile_page && tabIndex === 2">
      <div class="device-wall-sel-div">
        <!-- <img class="exclamation" alt="exclamation"/> -->
        <ng-template #popContentDeviceWallPaper>
          <div id="popOver" class="popover-upload-req">
            <div id="popOverContent" class="d-flex align-items-center device_wallpaper_hover_img">
              <span i18n="@@logo-content.device-wall-paper.note-text"><strong>Note:</strong>Shoppers can see device
                wallpaper only when they exit IPOS.</span>
            </div>
          </div>
        </ng-template>
        <label>
          <span class="set-wallpaper-label" i18n="@@logo-content.device-wall-paper.set-wallpaper">Customize desktop
            background</span>
          <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for walpaper" placement="right"
            [ngbPopover]="popContentDeviceWallPaper" container="body" triggers="mouseenter:mouseleave" />
        </label>
        <div id="btnWrapper" class="mt-2 d-flex">
          <button type="button" class="btn box-enclose">
            <div class="device-wallpaper-store-logo d-flex">
              <input type="checkbox" class="device-wallpaper-check-box" id="deviceWal"
                (click)="getLogoUploadImage('Make logo as wallpaper',$event)"
                [ngClass]="checkBtnStrLogo ? 'button-blue' : ''" [checked]="checkBtnStrLogo">
              <label for="deviceWal">
                <span>{{globConst.MAKE_LOGO_WALPAPER}}</span>
              </label>

            </div>

          </button>
          <button type="button" class="btn box-enclose">
            <div class="device-wallpaper-device-logo d-flex">
              <input type="checkbox" id="uploadWal" class="device-wallpaper-check-box"
                (click)="getLogoUploadImage('Upload Image',$event)" [checked]="checkBtnDwp"
                [ngClass]="checkBtnDwp ? 'button-blue' : ''">
              <label for="uploadWal">
                <span i18n="@@logo-content.device-wall-paper.upload-img">Upload Image</span>
              </label>

            </div>
          </button>
        </div>
        <div class="instr-text">
          <button type="button" class="btn box-enclose">
            <em class="caution_img"></em>&nbsp;<span i18n="@@logo-content.device-wall-paper.set-wallpaper-instr">Minimum
              recommended image resolution: 1280 X 720</span>
          </button>
        </div>
      </div>
    </div>

    <!-- tab panes -->
    <div id="storeContent" class="tab-content">
      <!-- Store Promo Tab -->
      <div id="storeTab" *ngIf="tabIndex === 0" id="storeLogos" class="tab-pane" [ngClass]="{'active': tabIndex === 0}">
        <ng-container *ngIf="presentPage === assets_page">
          <!-- Data header with info like no. of content groups, action buttons and filters -->
          <div id="storeData" class="data_header"
            [ngClass]="(otherStoreLogos?.length || defaultStoreLogos?.length) ? '' : 'display-block'">
            <span *ngIf="(otherStoreLogos?.length || defaultStoreLogos?.length)">
              <span *ngIf="otherStoreLogos && otherStoreLogos?.length == 1" id="dataTitle">{{otherStoreLogos?.length +
                defaultStoreLogos?.length}}&nbsp;{{logoContentText}}</span>
              <span id="dataTitle" *ngIf="otherStoreLogos && otherStoreLogos?.length > 1">{{otherStoreLogos?.length +
                defaultStoreLogos?.length}} <span i18n="@@logo-content.store-logos.count.name">Store Logos</span></span>
              <span class="sort-by-label" i18n="@@logo-content.sort-by">Sort by</span>:&nbsp;
              <div id="storeDropDown" ngbDropdown class="btn-group">
                <button ngbDropdownToggle type="button" class="btn btn-primary btn-sm dropdown-toggle"
                  id="storeDropDown">
                  {{storeLogoSortValue}}
                </button>
                <div id="storeDropDownMenu" ngbDropdownMenu aria-labelledby="storeDropDown">
                  <a ngbDropdownItem *ngIf="storeLogoSortValue!== uploadDateOption" (click)="sortBy('uploadDate')"><span
                      i18n="@@logo-content.store-logos.sort.upload-date">Upload Date</span></a>
                  <a ngbDropdownItem *ngIf="storeLogoSortValue!== fileNameOption" (click)="sortBy('fileName')"><span
                      i18n="@@logo-content.store-logos.sort.file-name">File Name</span></a>
                </div>
              </div>
            </span>
            <span *ngIf="!otherStoreLogos?.length && !defaultStoreLogos?.length"
              i18n="@@logo-content.store-logos.no-logos">You don’t have any logos
              saved.</span>
            <span class="data_action">
              <!-- <input type="file" name="fileToUpload" id="fileToUpload"
                                  (change)="selectFile($event)"> -->
              <!-- <input #imageInput type="file" accept="image/*" (change)="processFile(imageInput)" > -->
              <div id="uploadButton" class="d-flex flex-column"
                [ngClass]="{'align-items-end':otherStoreLogos?.length>0, 'align-items-start':!otherStoreLogos?.length}">
                <div id="uploadImg">
                  <label>
                    <input #imageInput id="uploadLogo" type="file"
                      accept="image/jpg,image/jfif,image/x-png,image/jpeg,image/gif" (click)="imageInput.value = null"
                      (change)="processFile(imageInput)">
                    <span class="btn btn-primary btn-sm left_icon_btn"><svg width="16" height="17" viewBox="0 0 16 17"
                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M0.5 8.25822C0.632608 8.25822 0.759785 8.3109 0.853553 8.40467C0.947322 8.49844 1 8.62561 1 8.75822V12.2582C1 12.5234 1.10536 12.7778 1.29289 12.9653C1.48043 13.1529 1.73478 13.2582 2 13.2582H14C14.2652 13.2582 14.5196 13.1529 14.7071 12.9653C14.8946 12.7778 15 12.5234 15 12.2582V8.75822C15 8.62561 15.0527 8.49844 15.1464 8.40467C15.2402 8.3109 15.3674 8.25822 15.5 8.25822C15.6326 8.25822 15.7598 8.3109 15.8536 8.40467C15.9473 8.49844 16 8.62561 16 8.75822V12.2582C16 12.7887 15.7893 13.2974 15.4142 13.6724C15.0391 14.0475 14.5304 14.2582 14 14.2582H2C1.46957 14.2582 0.960859 14.0475 0.585786 13.6724C0.210714 13.2974 0 12.7887 0 12.2582V8.75822C0 8.62561 0.0526784 8.49844 0.146447 8.40467C0.240215 8.3109 0.367392 8.25822 0.5 8.25822ZM5 5.11222C5.09376 5.20596 5.22092 5.25862 5.3535 5.25862C5.48608 5.25862 5.61324 5.20596 5.707 5.11222L8 2.81822L10.293 5.11122C10.3391 5.15898 10.3943 5.19707 10.4553 5.22327C10.5163 5.24948 10.5819 5.26327 10.6483 5.26385C10.7147 5.26442 10.7805 5.25177 10.842 5.22663C10.9034 5.20149 10.9593 5.16437 11.0062 5.11742C11.0531 5.07047 11.0903 5.01465 11.1154 4.9532C11.1406 4.89175 11.1532 4.82591 11.1526 4.75952C11.152 4.69313 11.1383 4.62752 11.1121 4.56652C11.0858 4.50552 11.0478 4.45035 11 4.40422L8.354 1.75822C8.30755 1.71166 8.25238 1.67472 8.19163 1.64951C8.13089 1.6243 8.06577 1.61133 8 1.61133C7.93423 1.61133 7.86911 1.6243 7.80837 1.64951C7.74762 1.67472 7.69245 1.71166 7.646 1.75822L5 4.40422C4.95344 4.45067 4.91649 4.50584 4.89129 4.56659C4.86608 4.62733 4.85311 4.69246 4.85311 4.75822C4.85311 4.82399 4.86608 4.88911 4.89129 4.94986C4.91649 5.0106 4.95344 5.06578 5 5.11222Z" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8 2.25781C8.13261 2.25781 8.25979 2.31049 8.35355 2.40426C8.44732 2.49803 8.5 2.6252 8.5 2.75781V10.7578C8.5 10.8904 8.44732 11.0176 8.35355 11.1114C8.25979 11.2051 8.13261 11.2578 8 11.2578C7.86739 11.2578 7.74021 11.2051 7.64645 11.1114C7.55268 11.0176 7.5 10.8904 7.5 10.7578V2.75781C7.5 2.6252 7.55268 2.49803 7.64645 2.40426C7.74021 2.31049 7.86739 2.25781 8 2.25781Z" />
                      </svg> <span i18n="@@logo-content.store-logos.upload-button">Upload Logo</span>
                    </span>
                  </label>
                  <ng-template #popContent>
                    <div id="popOver" class="popover-upload-req">
                      <div id="popOverImg" class="d-flex align-items-center">
                        <img src="assets/images/image-icon.png" alt="image" />
                        <ul [ngClass]="isImgVideoSizeInfoEnabled ? 'tooltip-list-style' : ''">
                          <li i18n="@@global.tooltip.image-rule-format">Images must be in <strong>JPG, PNG, JPEG,
                              JFIF</strong> or <strong>GIF</strong> format</li>
                          <li *ngIf="!isImgVideoSizeInfoEnabled"><span
                              i18n="@@global.tooltip.image-max-size-error">Allowed maximum size is <strong>5
                                MB</strong></span></li>
                        </ul>
                      </div>
                    </div>
                  </ng-template>
                  <img *ngIf="!otherStoreLogos?.length && !defaultStoreLogos?.length" class="info_icon"
                    src="assets/images/info_circle_icon.svg" alt="hover for help" placement="{{placementWithoutLogo}}"
                    [ngbPopover]="popContent" triggers="mouseenter:mouseleave" />
                  <img *ngIf="otherStoreLogos?.length < 1 && defaultStoreLogos?.length > 0" class="info_icon"
                    src="assets/images/info_circle_icon.svg" alt="hover for help" placement="{{placementWithLogo}}"
                    [ngbPopover]="popContent" triggers="mouseenter:mouseleave" />
                  <img *ngIf="otherStoreLogos?.length > 0 && defaultStoreLogos?.length < 1" class="info_icon"
                    src="assets/images/info_circle_icon.svg" alt="hover for help" placement="{{placementWithLogo}}"
                    [ngbPopover]="popContent" triggers="mouseenter:mouseleave" />
                  <img *ngIf="otherStoreLogos?.length > 0 && defaultStoreLogos?.length > 0" class="info_icon"
                    src="assets/images/info_circle_icon.svg" alt="hover for help" placement="{{placementWithLogo}}"
                    [ngbPopover]="popContent" triggers="mouseenter:mouseleave" />
                </div>
                <div id="ImageTypeError" *ngIf="isImageTypeError" class="uploadfile_err_msg error-width"><span
                    i18n="@@global.content-grp.image-rule-format">Incorrect file type received. Image must be in
                    <strong>JPG, PNG
                    </strong>or <strong>GIF</strong> format.</span>
                </div>
                <div id="ImageSizeError" *ngIf="isImageSizeError && isimageFormat" class="uploadfile_err_msg">
                  <span i18n="@@global.content-grp.image-max-size-error">File exceeds maximum size <strong>(5
                      MB).</strong></span>
                </div>
              </div>
            </span>
          </div>

          <!-- Data content with logo tiles in a row -->
          <div id="dataContent" class="data_content">
            <!-- When no default store logo available-->
            <div id="accordion" *ngIf="defaultStoreLogos?.length < 1 && otherStoreLogos?.length" class="accordion">
              <span class="logo_category" i18n="@@logo-content.store-logos.default-logo">Default Logos</span>
              <div id="storeLogo" class="default_logos_border">
                <div id="storeCard" class="card">
                  <div class="default_img_icon"></div>
                  <div class="default_card_text"><span i18n="@@logo-content.store-logos.set-default-logo">Set a logo as
                      your
                      default</span></div>
                </div>
              </div>
            </div>
            <!-- Default Logo-->
            <div id="defaultStoreLogos" *ngIf="defaultStoreLogos && defaultStoreLogos?.length" class="accordion">
              <span class="logo_category" i18n="@@logo-content.store-logos.default-logo">Default Logos</span>
              <div id="defaultLogosTiles" class="default_logos_tiles">
                <div id="storeLogo" *ngFor="let storeLogo of defaultStoreLogos; trackBy: trackByStoreLogo">
                  <div id="logoTile" class="default_logo_tile">
                    <!-- Other Logo - 2 -->
                    <div id="storeLogoCard" class="card">
                      <div id="logoImg" class="store_logo_img">
                        <img [src]="storeLogo.imageData" alt="Image Logo" class="store-logo-image" />
                      </div>
                      <div id="storeLogoCaption" class="store_logo_caption small_text">
                        <span class="store-logo-name" placement="top-left" container='body'
                          ngbTooltip={{storeLogo.fileName}}>{{storeLogo.shortFileName}}</span>
                        <span class="store-logo-action-button">
                          <span placement="top" ngbTooltip="{{deleteTooltipLabel}}"
                            (click)="openDeleteModalSL(storeLogo.id)">
                            <img class="delete_Icon_img" alt="delete" />
                          </span>
                          <iposcen-delete-popup #deleteStoreLogoModal [contentName]="logoToDeleteName"
                            [buttonName]="logoDeleteButton" (delete)="deleteStoreLogo(logoToDelete)">
                          </iposcen-delete-popup>
                          <span class="send-to-store-icon" *ngIf="isRetailerUser || isRegionalHQ" placement="top"
                            container='body' ngbTooltip="{{sendToStoreTooltipLabel}}">
                            <img class="send_Icon_img" alt="Send"
                              (click)="openDefaultStoreContentToAccountModal(storeLogo?.id)" />
                          </span>
                        </span>

                      </div>
                      <div id="storeLogoCardBody" class="card-body">
                        <div id="updateTime" class="small_text">
                          <strong><span i18n="@@logo-content.store-logos.uploaded">Uploaded</span></strong>
                          {{storeLogo.updateTime | dateFormat: "changeToLocalTimeZone" }}
                        </div>
                        <div id="pushedToDevice" *ngIf="storeLogo.ispushedToDevice" class="small_text"><strong><span
                              i18n="@@logo-content.store-logos.sent">Sent</span></strong>
                          {{storeLogo.sentTime}}
                        </div>
                        <div id="actionBtn" class="action_buttons">
                          <button *ngIf="!storeLogo?.isdefault" type="button"
                            (click)="setAsDefaultStoreLogo(storeLogo.id, true)"
                            class="btn btn-block btn-primary btn-sm gtmSetLogoDefault">
                            <span i18n="@@logo-content.store-logos.set-as-default">Set as Default</span>
                          </button>
                          <button *ngIf="storeLogo?.isdefault" type="button"
                            (click)="setAsDefaultStoreLogo(storeLogo.id, false)"
                            class="btn btn-block  btn-outline-primary btn-sm gtmRemoveDefault">
                            <span i18n="@@logo-content.store-logos.remove-as-default">Remove as Default</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Other logo ends here -->
                  </div>
                </div>
                <iposcen-send-to-segment-account #sendToAccountModal [sendName]="sendLogoImageName"
                  [sendButtonName]="sendLogoImageButtonText" (selectedStoreData)="getDefaultStoreLogoData($event)"
                  [sendToStoreSuccess]="isDefaultStoreSendToStore" (clearAllData)="isDefaultStoreSendToStore=false">
                </iposcen-send-to-segment-account>
              </div>
            </div>
            <!-- Other Logos-->
            <div class="GuideLogo"
              [ngClass]="defaultStoreLogos?.length < 1 && otherStoreLogos?.length ? 'col-8' :'col-7'">
              <div class="card-container" class="guideline-header">
                <span i18n="@@logo-content.store-logos-guidelines">Guidelines for using store logos</span>
                <div class="guidelines">
                  <div>
                    <img src="assets/images/blackLogo.png" class="card-img-top-p" alt="...">
                    <div class="card-body-text">
                      <img src="assets/images/blockSign.png" alt="close icon" />
                      <span class="card-text" i18n="@@logo-content.store-logos-guidelines-coloured-background">Do not
                        use black on a coloured background</span>
                    </div>
                  </div>
                  <div>
                    <img src="assets/images/greyLogo.png" class="card-img-top-p" alt="...">
                    <div class="card-body-text">
                      <img src="assets/images/blockSign.png" alt="close icon" />
                      <span class="card-text" i18n="@@logo-content.store-logos-guidelines-weak-contrast">Do not use weak
                        contrast</span>
                    </div>
                  </div>
                  <div>
                    <img src="assets/images/whiteLogo.png" class="card-img-top-p" alt="...">
                    <div class="card-body-text">
                      <img src="assets/images/tickMark.png" alt="close icon" />
                      <span class="card-text" i18n="@@logo-content.store-logos-guidelines-good-contrast">Maintain good
                        contrast at all times</span>
                    </div>
                  </div>
                </div>
              </div>
              <div id="otherLogo" *ngIf="otherStoreLogos && otherStoreLogos?.length" class="other_logos_column">
                <span class="logo_category" i18n="@@logo-content.store-logos.other-logos">Other Logos</span>
                <div id="otherLogoTiles" class="other_logos_tiles">
                  <div id="storeLogoObj" *ngFor="let storeLogo of otherStoreLogos; trackBy: trackByStoreLogo">
                    <!-- Other Logo - 2 -->
                    <div id="storeLogoObjCard" class="card">
                      <div id="storeLogoObjImg" class="store_logo_img">
                        <img [src]="storeLogo.imageData" alt="Image Logo" class="store-logo-image" />
                      </div>
                      <div id="storeLogoCaps" class="store_logo_caption small_text ">
                        <span class="store-logo-name" placement="top-left" container='body'
                          ngbTooltip={{storeLogo.fileName}}>{{storeLogo.shortFileName}}</span>
                        <span class="store-logo-action-button">
                          <span placement="top" ngbTooltip="{{deleteTooltipLabel}}"
                            (click)="openDeleteModalSL(storeLogo.id)">
                            <img class="delete_Icon_img" alt="delete" />
                          </span>
                          <iposcen-delete-popup #deleteStoreLogoModal [contentName]="logoToDeleteName"
                            [buttonName]="logoDeleteButton" (delete)="deleteStoreLogo(logoToDelete)">
                          </iposcen-delete-popup>
                          <span class="send-to-store-icon" *ngIf="isRetailerUser || isRegionalHQ" placement="top"
                            container='body' ngbTooltip="{{sendToStoreTooltipLabel}}"
                            (click)="openOtherStoreContentToAccountModal(storeLogo?.id)">
                            <img class="send_Icon_img" alt="Send" />
                          </span>
                        </span>
                      </div>
                      <div id="storeLogoObjCardBody" class="card-body">
                        <div id="storeUpdatedTime" class="small_text">
                          <strong><span i18n="@@logo-content.store-logos.uploaded">Uploaded</span></strong>
                          {{storeLogo.updateTime | dateFormat: "changeToLocalTimeZone"}}
                        </div>
                        <div id="storepushedToDevice" *ngIf="storeLogo.ispushedToDevice" class="small_text">
                          <strong><span i18n="@@logo-content.store-logos.sent">Sent</span></strong>
                          {{storeLogo.sentTime}}
                        </div>
                        <div id="actionsBtn" class="action_buttons">
                          <button *ngIf="!storeLogo?.isdefault" type="button"
                            (click)="setAsDefaultStoreLogo(storeLogo.id, true)"
                            class="btn btn-primary btn-sm btn-block gtmSetLogoDefaultOthr">
                            <span i18n="@@logo-content.store-logos.set-as-default">Set as Default</span>
                          </button>
                          <button *ngIf="storeLogo?.isdefault" type="button"
                            (click)="setAsDefaultStoreLogo(storeLogo.id, false)"
                            class="btn btn-block btn-outline-primary btn-sm gtmRemoveDefault">
                            <span i18n="@@logo-content.store-logos.remove-as-default">Remove as Default</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Other logo ends here -->
                  </div>
                  <iposcen-send-to-segment-account #sendToAccountModal [sendName]="sendLogoImageName"
                    [sendButtonName]="sendLogoImageButtonText" (selectedStoreData)="getOtherStoreLogoData($event)"
                    [sendToStoreSuccess]="isOtherStoreSendToStore" (clearAllData)="isOtherStoreSendToStore=false">
                  </iposcen-send-to-segment-account>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="presentPage === profile_page">
          <iposcen-profile-storelogo (setLogoContentTab)="presentPage === profile_page" (setTabIndex)="setIndex(1)"
            (setTabIndexDWP)="setIndex(2)" (disabledLogoContentTab)="disabledLogoContent(isDisabled)"
            (currentStoreLogoCount)="getLogocontentParams($event)" [logoPresentPage]="presentPage"
            [wallpaperTab]="false" [iposlite]="this.setIposliteEnabled"></iposcen-profile-storelogo>
        </ng-container>
      </div>

      <!-- Device wallpaper Tab Contents -->
      <div class="device-wallpaper" *ngIf="tabIndex === 2">
        <!-- Store Logo section -->
        <div *ngIf="checkBtnStrLogo && !checkBtnDwp" class="tab-pane" [ngClass]="{'active': tabIndex === 2}">
          <ng-container *ngIf="presentPage === profile_page">
            <iposcen-profile-storelogo (disabledLogoContentTab)="disabledLogoContent(isDisabled)"
              [deviceWallPaper]="deviceWallPaper" [wallpaperTab]="true"
              [logoPresentPage]="presentPage"></iposcen-profile-storelogo>
          </ng-container>
        </div>

        <!-- Upload Image section -->

        <div *ngIf="checkBtnDwp && !checkBtnStrLogo" class="tab-pane" [ngClass]="{'active': tabIndex === 2}">
          <div class="device-wallpaper-upload">
            <div class="device-wallpaper-buttons">
              <div class="upload-btn">
                <div class="image-sec">
                  <span i18n="@@logo-content.device-wall-paper.img-text-dwp" class="img-text">Image</span>
                  <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for walpaper"
                    placement="right" [ngbPopover]="deviceWallPaperUpload" container="body"
                    triggers="mouseenter:mouseleave" />
                  <ng-template #deviceWallPaperUpload>
                    <div class="d-flex justify-content-center align-items-center">
                      <img style="height: 24px; width: 24px;" src="assets/images/image-icon.png" alt="image-icon-alt" />
                      <div>
                        <ul class="pop-over-device-wallpaper"
                          [ngClass]="isImgVideoSizeInfoEnabled ? 'tooltip-list-style' : ''">
                          <li [innerHTML]="wallPaperImagUpload"></li>
                          <li *ngIf="!isImgVideoSizeInfoEnabled" i18n="@@global.tooltip.image-max-size-error">Allowed
                            maximum size is <strong>5 MB</strong></li>
                        </ul>
                      </div>
                    </div>
                  </ng-template>
                </div>
                <label>
                  <input #imageInput id="uploadLogo" type="file" accept="image/jpg,image/jfif,image/x-png,image/jpeg"
                    (click)="imageInput.value = null" (change)="uploadImgDeviceWallPaper(imageInput)">
                  <span class="btn btn-primary btn-sm left_icon_btn"><svg width="16" height="17" viewBox="0 0 16 17"
                      fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.5 8.25822C0.632608 8.25822 0.759785 8.3109 0.853553 8.40467C0.947322 8.49844 1 8.62561 1 8.75822V12.2582C1 12.5234 1.10536 12.7778 1.29289 12.9653C1.48043 13.1529 1.73478 13.2582 2 13.2582H14C14.2652 13.2582 14.5196 13.1529 14.7071 12.9653C14.8946 12.7778 15 12.5234 15 12.2582V8.75822C15 8.62561 15.0527 8.49844 15.1464 8.40467C15.2402 8.3109 15.3674 8.25822 15.5 8.25822C15.6326 8.25822 15.7598 8.3109 15.8536 8.40467C15.9473 8.49844 16 8.62561 16 8.75822V12.2582C16 12.7887 15.7893 13.2974 15.4142 13.6724C15.0391 14.0475 14.5304 14.2582 14 14.2582H2C1.46957 14.2582 0.960859 14.0475 0.585786 13.6724C0.210714 13.2974 0 12.7887 0 12.2582V8.75822C0 8.62561 0.0526784 8.49844 0.146447 8.40467C0.240215 8.3109 0.367392 8.25822 0.5 8.25822ZM5 5.11222C5.09376 5.20596 5.22092 5.25862 5.3535 5.25862C5.48608 5.25862 5.61324 5.20596 5.707 5.11222L8 2.81822L10.293 5.11122C10.3391 5.15898 10.3943 5.19707 10.4553 5.22327C10.5163 5.24948 10.5819 5.26327 10.6483 5.26385C10.7147 5.26442 10.7805 5.25177 10.842 5.22663C10.9034 5.20149 10.9593 5.16437 11.0062 5.11742C11.0531 5.07047 11.0903 5.01465 11.1154 4.9532C11.1406 4.89175 11.1532 4.82591 11.1526 4.75952C11.152 4.69313 11.1383 4.62752 11.1121 4.56652C11.0858 4.50552 11.0478 4.45035 11 4.40422L8.354 1.75822C8.30755 1.71166 8.25238 1.67472 8.19163 1.64951C8.13089 1.6243 8.06577 1.61133 8 1.61133C7.93423 1.61133 7.86911 1.6243 7.80837 1.64951C7.74762 1.67472 7.69245 1.71166 7.646 1.75822L5 4.40422C4.95344 4.45067 4.91649 4.50584 4.89129 4.56659C4.86608 4.62733 4.85311 4.69246 4.85311 4.75822C4.85311 4.82399 4.86608 4.88911 4.89129 4.94986C4.91649 5.0106 4.95344 5.06578 5 5.11222Z" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M8 2.25781C8.13261 2.25781 8.25979 2.31049 8.35355 2.40426C8.44732 2.49803 8.5 2.6252 8.5 2.75781V10.7578C8.5 10.8904 8.44732 11.0176 8.35355 11.1114C8.25979 11.2051 8.13261 11.2578 8 11.2578C7.86739 11.2578 7.74021 11.2051 7.64645 11.1114C7.55268 11.0176 7.5 10.8904 7.5 10.7578V2.75781C7.5 2.6252 7.55268 2.49803 7.64645 2.40426C7.74021 2.31049 7.86739 2.25781 8 2.25781Z" />
                    </svg> <span i18n="@@logo-content.device-wall-paper.upload-button">Upload Image</span>
                  </span>
                </label>
              </div>
              <div class="color-picker-device-wallpaper" [ngClass]="!imgFileName ? 'color-picker-disabled' : ''"
                *ngIf="imgFileName && isimageFormatDeviceWallppr">
                <span i18n="@@logo-content.device-wall-paper.bg-color-button-desktop"
                  class="background-color-device">Desktop Background</span>
                <input [disabled]="!imgFileName" [(colorPicker)]="bgColorSelected"
                  [ngStyle]="{'background-color':bgColorSelected}" class="color_picker_button" name="bgColorSelected"
                  (colorPickerChange)="changeColorPicker($event)" readonly />
              </div>

            </div>
            <div class="uploaded-file-name btn btn-sm"
              *ngIf="!isImageSizeErrorDeviceWallppr && !isImageTypeErrorDeviceWallppr && imgFileName" id="imgFileName">
              {{imgFileName}}
            </div>
            <div id="storeLogosImageTypeError" *ngIf="isImageTypeErrorDeviceWallppr"
              class="uploadfile_err_msg error-msg-width">
              <span i18n="@@logo-content.logo-content-groups.image-format-error-text">Incorrect file type received.
                Image must be in <strong>JPG, PNG, JPEG</strong> or <strong>JFIF</strong> format.</span>
            </div>
            <div id="storeLogosImageSizeError" *ngIf="isImageSizeErrorDeviceWallppr" class="uploadfile_err_msg">
              <span i18n="@@global.content-grp.image-max-size-error">File exceeds maximum size <strong>(5
                  MB).</strong></span>
            </div>
          </div>
        </div>
        <div id="btnWrapper" class="button-wrapper justify-content-end mb-4 mx-4"
          *ngIf="checkBtnDwp || !checkBtnStrLogo">
          <button type="button" class="btn btn-outline-primary gtmAssetLibraryLogoContentSkip"
            (click)="sendToProfile('skipdwp')">
            <span i18n="@@logo-content.logo-content-groups.skip">Skip</span>
          </button>
          <button type="button" class="btn btn-primary gtmAssetLibraryLogoContentSaveAndContinue"
            (click)="sendToProfile('sendDeviceWalppr')">
            <span class="gtmAssetLibraryLogoContentSaveAndContinue"
              i18n="@@logo-content.logo-content-groups.save-and-continue">Save and Continue</span>
          </button>
        </div>
      </div>

      <!-- Logo Content Group Tab -->
      <div *ngIf="tabIndex === 1" id="logoContentGroups" class="tab-pane" [ngClass]="{'active': tabIndex === 1}">
        <!-- Data header with info like no. of content groups, action buttons and filters -->
        <div id="logoContentGrpsData" class="data_header"
          [ngClass]="(displayLogoContentGroups?.length) ? '' : 'display-block' ">
          <ng-container *ngIf="presentPage === assets_page">
            <span *ngIf="displayLogoContentGroups?.length">
              <span *ngIf="displayLogoContentGroups && displayLogoContentGroups?.length == 1"
                id="dataTitle">{{displayLogoContentGroups?.length}} {{logoContentGroupLabel}}</span>
              <span *ngIf="displayLogoContentGroups && displayLogoContentGroups?.length > 1"
                id="dataTitle">{{displayLogoContentGroups?.length}}
                <span i18n="@@logo-content.logo-content.count.name">Logo Content Groups</span></span>
              <span *ngIf="displayLogoContentGroups?.length > 1">
                <span class="sort-by-label" i18n="@@logo-content.sort-by">Sort by</span>:&nbsp;
                <div ngbDropdown class="btn-group">
                  <button ngbDropdownToggle class="btn btn-primary btn-sm dropdown-toggle"
                    id="sortDropDown">{{sortValue}}
                  </button>
                  <div class="sort-dropdown" ngbDropdownMenu aria-labelledby="sortDropDown">
                    <button ngbDropdownItem *ngIf="sortValue!=createdDateVal"
                      (click)="sortBy('createDate')">{{createdDateVal}}</button>
                    <button ngbDropdownItem *ngIf="sortValue!=groupNameVal"
                      (click)="sortBy('groupName')">{{groupNameVal}}</button>
                  </div>
                </div>
              </span>
            </span>
            <span *ngIf="!displayLogoContentGroups?.length"
              i18n="@@logo-content.logo-content-groups.add-lgc-upto-3-pages">Add a
              Logo Content Group of up to 3 pages
              to your
              logo.</span>
          </ng-container>
          <ng-container *ngIf="presentPage === profile_page && displayLogoContentGroups?.length">
            <div id="storeAddToPckg">
              <div id="addToPckgContent">
                <strong><span i18n="@@logo-content.logo-content-groups.add-to-package">Added to Package</span>:</strong>
                {{ selctedContGrpsForProfile.contentGrps?.length || '0'}}
                <span i18n="@@logo-content.add-to-package.count.contentgrps">Content Groups</span>
              </div>
              <div id="showOnDeviceContent">
                <strong><span i18n="@@logo-content.logo-content-groups.show-on-device">Show on Device</span>:</strong>
                {{ selctedContGrpsForProfile.showOnDevice ? '1' : '0'}}
                <span i18n="@@logo-content.add-to-package.count.contentgrps">Content Groups</span>
              </div>
            </div>
          </ng-container>
          <strong *ngIf="presentPage === profile_page && !displayLogoContentGroups?.length"><span
              i18n="@@logo-content.logo-length-no-logo-content-group-has-been-created">No Logo Content Group
              has been
              created.</span></strong>
          <span class="data_action" *ngIf="!deviceStoreLogoOtherData">
            <button type="button" id="uploadLogo"
              class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryLogoContentCreateNewLogoContent"
              (click)="createNewLogoContent()">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="16" height="16" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
              <span i18n="@@logo-content.logo-content-groups.new-logo-content-groups">New Logo Content Group</span>
            </button>
          </span>
        </div>
        <ng-container *ngIf="presentPage === profile_page">
          <div id="addLCG" *ngIf="displayLogoContentGroups?.length" class="mt-3 mb-3">
            <span i18n="@@logo-content.logo-content-groups.add-lgc-upto-3-pages">Add a Logo Content Group of up
              to 3 pages to your logo.</span><br />
            <strong><span i18n="@@logo-content.logo-content-groups.add-upto-3-lgc">You may add up to 3 Logo
                Content Groups.</span></strong>
          </div>
        </ng-container>


        <!-- Data Content -->
        <div id="dataSegments" class="data_content segments_only" *ngIf="displayLogoContentGroups?.length > 0"
          [ngClass]="presentPage === profile_page?'acc_table_view':''">
          <div id="showOnDeviceSelect2" class="show_on_device_select" *ngIf="presentPage === profile_page">
            <div id="showOnDeviceLabel" class="small_text border-right shown-on-device-label"><span
                i18n="@@segments.shown-on-device-label">Show on Device</span></div>
            <div id="contentGrps"><span i18n="@@logo-content.add-to-package.count.contentgrps">Content Groups</span>
            </div>
          </div>
          <div class="accordion" id="logoContentAccordian">
            <!-- Group 1 -->
            <div id="logoContentCard" class="card" *ngIf="presentPage === profile_page || presentPage === device_page ">
              <div id="logoContentCardHeader" class="card-header small_text">
                <div id="logoContentCardAccCheck" class="acc_check">
                  <div id="logoContentRadio" class="form-check">
                    <input type="radio" name="cpLCGSelect" class="form-check-input" value="isLogoNone"
                      (change)='removeShowonDevice()' [checked]="isLogoNone" />
                  </div>
                </div>
                <div id="logoContentCardHeaderContent" class="card-header-content">
                  <div id="logoContentCardHeaderData" class="d-flex">
                    <div id="libSelectNone" class="select_none">
                      <span i18n="@@hero-tile.asset-library.none">None</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="segmentCard" class="card"
              *ngFor="let logoContentGroup of displayLogoContentGroups | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
              <div class="card-header small_text" id="segmentOne">
                <div id="segmentAccCheck" class="acc_check"
                  *ngIf="presentPage === profile_page || deviceStoreLogoOtherData">
                  <div id="segmentRadio" class="form-check"
                    [ngbPopover]="(!logoContentGroup.addToPackage && !deviceStoreLogoOtherData) ? showonDeviceDisabled:''"
                    [placement]="changePlacement == true ? 'left' : 'right'" triggers="mouseenter:mouseleave">
                    <input type="radio" (click)="getDeviceLogoContentId(logoContentGroup)" name="cpLCGSelect"
                      class="form-check-input" [value]="logoContentGroup.showOnDevice"
                      [checked]="logoContentGroup.showOnDevice"
                      (change)="addToProfile($event,logoContentGroup.index,'radio')"
                      [disabled]="!logoContentGroup.addToPackage && !deviceStoreLogoOtherData" />
                  </div>
                </div>
                <div id="segmentsCardHeader" class="card-header-content">
                  <div id="segmentTitle" class="title_left">
                    <div id="segmentData" class="d-flex">
                      <div id="publishedName" class="title">
                        <span>{{logoContentGroup.configurations.publishedName}} &nbsp;&nbsp;</span>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div *ngIf="(logoContentGroup.isContentExpires)" id="contentExpire" class="content-expire"><img
                          class="contents-info-icon" alt="info_icon"><span>{{globConst.CONT_GRP_EXPIRED_TEXT}}</span>
                      </div>
                      <div id="editBtn" class="d-flex"
                        *ngIf="presentPage === assets_page && ((!logoContentGroup.islocked && isStoreUser) || !isStoreUser)">
                        <button type="button" placement="bottom" ngbTooltip="{{editTooltipLabel}}"
                          (click)="editLogoContent(logoContentGroup.id)" class="btn gtmEditSegment">
                          <img alt="Edit" />
                        </button>
                        <button type="button" placement="bottom" ngbTooltip="{{deleteTooltipLabel}}"
                          (click)="openDeleteModal(logoContentGroup.id)" class="btn gtmDeleteSegment">
                          <img alt="Delete" />
                        </button>
                        <iposcen-delete-popup #deleteModal [contentName]="logoCGToDeleteName"
                          [buttonName]="logoContentDeleteButton" (delete)="deleteLogoCG(logoCGToDelete)">
                        </iposcen-delete-popup>
                        <button type="button" *ngIf="isRetailerUser || isRegionalHQ"
                          class="btn gtmSendLogoContGrp gtmSendBtn" placement="bottom"
                          ngbTooltip="{{sendToStoreTooltipLabel}}" container="body"
                          (click)="openSendLogoContentToAccountModal(logoContentGroup?.id)">
                          <img alt="Send" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div id="otherData" class="other_data" *ngIf="!deviceStoreLogoOtherData">
                    <div id="assetIDCopy">
                      <iposcen-assetid-copy [assetID]="logoContentGroup.id" *ngIf="presentPage === assets_page">
                      </iposcen-assetid-copy>
                      <div id="createdByLabel" class="subtitle_group subtitle-group-text">
                        <span class="subtitle"> <span i18n="@@logo-content.logo-content-groups.created-by">Created
                            By</span>:
                          {{logoContentGroup?.createdByUser}}
                        </span>
                        <span class="subtitle"><span i18n="@@logo-content.logo-content-groups.last-edited-by">Last
                            Edited By</span>
                          {{logoContentGroup?.createdByUser}}:
                          {{logoContentGroup.updateTime | dateFormat: "changeToLocalTimeZone"}}

                        </span>
                        <span class="subtitle" *ngIf="presentPage === assets_page && userRole !== 'nonConnectedUser'">
                          <span i18n="@@logo-content.logo-content-groups.pushed-to-all-devices">Pushed to all
                            devices</span>:
                          {{logoContentGroup?.ispushedToDevice ? YES: NO}}
                        </span>
                        <span *ngIf="logoContentGroup?.configurations?.internalName"
                          class="subtitle"><span>{{internalName}}:</span>
                          {{logoContentGroup?.configurations?.internalName}}
                        </span>
                      </div>

                      <div id="logoContentGroupCheckbox" class="form-check mt-3" *ngIf="presentPage === profile_page"
                        [ngbPopover]="(selctedContGrpsForProfile.contentGrps?.length === 3 && !logoContentGroup.addToPackage) ? addToPackageDisabled:''"
                        placement="top-left" triggers="mouseenter:mouseleave">
                        <input class="form-check-input" type="checkbox" [value]="logoContentGroup.addToPackage"
                          [checked]="logoContentGroup.addToPackage"
                          (change)="addToProfile($event,logoContentGroup.index,'check')"
                          [id]="'addToPackOne'+logoContentGroup.index"
                          [disabled]="selctedContGrpsForProfile.contentGrps?.length === 3 && !logoContentGroup.addToPackage" />
                        <label class="form-check-label" [for]="'addToPackOne'+logoContentGroup.index"
                          i18n="@@logo-content.logo-content-groups.add-to-package">
                          Add to Package
                        </label>
                      </div>
                    </div>
                    <div id="gtmlockSec" class="d-flex"
                      *ngIf="presentPage === assets_page && logoContentGroup.islocked && isStoreUser">
                      <div id="gtmlockIcon" class="gtmlockIcon lock-icon">
                        <img alt="content locked" />
                        <span class="pl-1 pt-1">{{lockContentText}}</span>
                      </div>
                    </div>
                    <div id="lockContentStatus" class="custom-control custom-switch"
                      *ngIf="(presentPage === assets_page) && (userRole === retailHqUser || userRole === regionalHqUser)">
                      <input type="checkbox" class="custom-control-input" [id]="'lockContent'+logoContentGroup?.id"
                        [checked]="logoContentGroup?.islocked" [value]="logoContentGroup?.islocked"
                        (click)=changeLockContentStatus(logoContentGroup?.id,$event,logoContentGroup) />
                      <label class="custom-control-label" [for]="'lockContent'+logoContentGroup?.id"
                        i18n="@@logo-content.logo-content-groups.lock-content">Lock Content</label>
                    </div>
                  </div>
                </div>
                <div id="collapseLink" class="collapse_link collapsed collapse-button {{logoContentGroup?.id}}"
                  type="button" (click)="getDetailsOfLogoCG(logoContentGroup?.id)"
                  [ngClass]="logoContentGroup.isExpanded ? 'transform-180' : ''">
                  <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                  </svg>
                </div>
              </div>
              <div id="collapseThree" class="collapse logoContentPreview" #collapse="ngbCollapse"
                [(ngbCollapse)]="!logoContentGroup.isExpanded" aria-labelledby="logoCGThree"
                data-parent="#logoContentAccordian">
                <div id="logoContentPreviewCardBody" class="card-body"
                  [ngClass]="presentPage === profile_page?'':'card-body-asset'">
                  <!-- IIT2-4653-->
                  <div id="logoContentPreviewNav" class="clearfix">
                    <ul class="nav nav-tabs float-left" role="tablist"
                      *ngIf="logoContentGroup.configurations?.contentGroupPages?.length">
                      <li class="nav-item">
                        <a class="nav-link gtmAssetLibraryLogoContentTitle" data-toggle="tab"
                          [ngClass]="{'active': logoContentGroup.previewTabIndex === 0}"
                          (click)="previewNavigate(0, logoContentGroup.id)">
                          <span placement="top" container='body' i18n="@@hero-tile.asset-library.main-content">Main
                            content</span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link gtmAssetLibraryLogoContentTitle" data-toggle="tab"
                          [ngClass]="{'active': logoContentGroup.previewTabIndex === 1}"
                          (click)="previewNavigate(1, logoContentGroup.id)">
                          <span placement="top" container='body' i18n="@@hero-tile.asset-library.page-content">Page
                            contents</span>
                        </a>
                      </li>
                    </ul>
                    <div id="duplicateBtn" *ngIf='!deviceStoreLogoOtherData'
                      class="duplicate-and-edit-span float-right">
                      <button (click)="duplicateAndEditLogoContent(logoContentGroup.id)" type="button"
                        class="btn btn-primary btn-sm left_icon_btn gtmDuplicateContGrp">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3 2H11C11.5304 2 12.0391 2.21071 12.4142 2.58579C12.7893 2.96086 13 3.46957 13 4V14C13 14.5304 12.7893 15.0391 12.4142 15.4142C12.0391 15.7893 11.5304 16 11 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2V2ZM3 3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H11C11.2652 15 11.5196 14.8946 11.7071 14.7071C11.8946 14.5196 12 14.2652 12 14V4C12 3.73478 11.8946 3.48043 11.7071 3.29289C11.5196 3.10536 11.2652 3 11 3H3Z"
                            fill="white" />
                          <path
                            d="M5 0H13C13.5304 0 14.0391 0.210714 14.4142 0.585786C14.7893 0.960859 15 1.46957 15 2V12C15 12.5304 14.7893 13.0391 14.4142 13.4142C14.0391 13.7893 13.5304 14 13 14V13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12V2C14 1.73478 13.8946 1.48043 13.7071 1.29289C13.5196 1.10536 13.2652 1 13 1H5C4.73478 1 4.48043 1.10536 4.29289 1.29289C4.10536 1.48043 4 1.73478 4 2H3C3 1.46957 3.21071 0.960859 3.58579 0.585786C3.96086 0.210714 4.46957 0 5 0V0Z"
                            fill="white" />
                        </svg>
                        <span i18n="@@logo-content.logo-content-groups.duplicate-edit">Duplicate and Edit</span>
                      </button>
                    </div>
                  </div>
                  <div id="IdleExperiencePreviewSection" *ngIf="logoContentGroup.previewTabIndex === 1"
                    class="form-group idleExperiencePreviewSection">
                    <form>
                      <div [ngClass]="{'width-Added-other-language': ['cs','pl'].includes(globConst.IPOS_LANGUAGE)}">
                        <input type="radio" name="ptLCGSelect" class="form-check-input"
                          value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS
                          (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS,logoContentGroup?.id)"
                          [checked]="globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS ==  logoContentGroup.isIdleExperienceEnabled" />
                        <label class="form-check-input" for="isIdleExperiencePreview">
                          {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS}}
                        </label>
                      </div>
                      <div>
                        <input type="radio" name="ptLCGSelect" class="form-check-input"
                          value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE
                          [checked]="globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE ==  logoContentGroup.isIdleExperienceEnabled"
                          (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE,logoContentGroup?.id)" />
                        <label class="form-check-input" for="isIdleExperiencePreview">
                          {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE}}
                        </label>
                      </div>
                    </form>
                  </div>
                  <div id="tabContent" class="tab-content">
                    <div id="tabPane" *ngIf="logoContentGroup.previewTabIndex === 0" id="storeLogos"
                      class="tab-pane pl-0 view_herotile_details"
                      [ngClass]="{'active': logoContentGroup.previewTabIndex === 0}">
                      <div id="priceContent" class="clearfix">
                        <div id="publishDateTime" class="float-left column col-md-4">
                          <div id="DateTime" class="pb-4">
                            <span i18n="@@price-content.group-tab.publish-date-time" class="font-weight-bold">Publishing
                              Date and
                              Time</span>
                            <div id="publishTime2">{{logoContentGroup?.configurations?.publishTime | dateFormat:
                              "24hrP"}}</div>
                          </div>
                          <div id="expirationDateTime">
                            <span i18n="@@price-content.group-tab.expiration-date-time"
                              class="font-weight-bold">Expiration Date
                              and Time</span>
                            <div>{{logoContentGroup?.configurations?.expireTime | dateFormat: "24hrP"}}</div>
                          </div>
                        </div>
                        <div id="configuration" class="float-left col-md-8"
                          *ngIf="logoContentGroup?.configurations?.formFactor">
                          <div id="nameBreak" class="name-break">
                            <table class="table-borderless form-factors-main-div mt-0" aria-describedby="formFactors">
                              <tr>
                                <th scope="col" class="pb-1"><span
                                    i18n="@@banner-carousel.content-group-applies-to">Content Group
                                    Applies
                                    To</span>: </th>
                              </tr>
                              <tr>
                                <td><strong><span>{{globConst.DEVICE_TYPES}}</span>: </strong>
                                  {{ logoContentGroup?.configurations?.formFactor?.devices.length ?
                                  logoContentGroup?.configurations?.formFactor?.devices : globConst.ALL}}
                                </td>
                              </tr>
                              <tr>
                                <td><strong><span>{{globConst.MANUFACTURERS}}</span>:</strong>
                                  {{ logoContentGroup?.configurations?.formFactor?.manufacturer.length ?
                                  logoContentGroup?.configurations?.formFactor?.manufacturer : globConst.ALL}}
                                </td>
                              </tr>
                              <tr>
                                <td><strong><span>{{globConst.PROCESSORS}}</span>: </strong>
                                  {{ logoContentGroup?.configurations?.formFactor?.processors.length ?
                                  logoContentGroup?.configurations?.formFactor?.processors :
                                  globConst.ALL}}
                                </td>
                              </tr>
                              <tr>
                                <td><strong><span>{{globConst.GENERATIONS}}</span>:</strong>
                                  {{ logoContentGroup?.configurations?.formFactor?.generations.length ?
                                  logoContentGroup?.configurations?.formFactor?.generations :
                                  globConst.ALL}}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="logoContentGroup.previewTabIndex === 1" id="storeLogos" class="tab-pane pl-0"
                      [ngClass]="{'active': logoContentGroup.previewTabIndex === 1}">
                      <div id="newwinDetailPage" class="detailpage__content newwin_detail_page">
                        <div id="mainContainer" class="main-container">
                          <div id="pageData" class="d-flex ">
                            <ng-container *ngFor="let page of logoContentGroup.configurations.contentGroupPages">
                              <iposcen-mini-live-preview [data]="loadMiniPreview(logoContentGroup?.id,page)"
                                [isIdleExperienceEnable]="logoContentGroup.isIdleExperienceEnabled">
                              </iposcen-mini-live-preview>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- IIT2-4653 end-->
                </div>
              </div>
            </div>
            <iposcen-send-to-segment-account #sendToAccountModal [sendName]="sendNameToStore"
              [sendButtonName]="sendButtonText" (selectedStoreData)="getSelectedStoreData($event)"
              [sendToStoreSuccess]="isSendToStore" (clearAllData)="isSendToStore=false">
            </iposcen-send-to-segment-account>
          </div>
        </div>

        <!-- Data Footer - Pagination -->
        <div id="stoeDataFooter" class="data_footer">
          <nav aria-label="logo content pagination"
            *ngIf="displayLogoContentGroups && displayLogoContentGroups?.length">
            <ngb-pagination [collectionSize]="displayLogoContentGroups?.length" [(page)]="page" [pageSize]="pageSize"
              [rotate]="true" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"></ngb-pagination>
          </nav>
        </div>
        <ng-container *ngIf="presentPage === profile_page">
          <div id="btnWrapper" class="button-wrapper justify-content-end">
            <button type="button" class="btn btn-outline-primary gtmAssetLibraryLogoContentSkip"
              (click)="sendToProfile('skip')">
              <span i18n="@@logo-content.logo-content-groups.skip">Skip</span>
            </button>
            <button type="button" class="btn btn-primary gtmAssetLibraryLogoContentSaveAndContinue"
              (click)="sendToProfile('send')" [disabled]="displayLogoContentGroups?.length === 0">
              <span class="gtmAssetLibraryLogoContentSaveAndContinue"
                i18n="@@logo-content.logo-content-groups.save-and-continue">Save and Continue</span>
            </button>
          </div>
        </ng-container>
      </div>

      <ng-container>
        <div id="createLogoContent" *ngIf="tabIndex === 3">
          <!-- <iposcen-create-logo-content (goBacktoLogoContent)="reloadLogoContent(1)"></iposcen-create-logo-content> -->
          <iposcen-create-logo-content [isNavigated]="isNavigated" [logoPresentPage]="presentPage"
            (goBacktoLogoContent)="setCreatedGrpID($event)">
          </iposcen-create-logo-content>
        </div>
        <div id="pageContent1" *ngIf="tabIndex === 4">
          <iposcen-page [cntgrpdata]="contentGrpData" #page1 [contentGroupType]="pageType" [pageNumber]=1
            [mediaObjs]="mediaObjects" [disableColors]="disableFields()" (goBacktoLogoContent)="refreshLGCdata()"
            (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
        </div>
        <div id="pageContent2" *ngIf="tabIndex === 5">
          <iposcen-page [cntgrpdata]="contentGrpData" #page2 [contentGroupType]="pageType" [pageNumber]=2
            [mediaObjs]="mediaObjects" [disableColors]="disableFields()" (goBacktoLogoContent)="refreshLGCdata()"
            (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
        </div>
        <div id="pageContent3" *ngIf="tabIndex === 6">
          <iposcen-page [cntgrpdata]="contentGrpData" #page3 [contentGroupType]="pageType" [pageNumber]=3
            [mediaObjs]="mediaObjects" [disableColors]="disableFields()" (goBacktoLogoContent)="refreshLGCdata()"
            (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
        </div>
      </ng-container>
      <!-- TODO: Move style to a class below -->
      <div id="addPageBtn" class="button-wrapper mb-4 mr-4 footer-btn"
        *ngIf="tabIndex === 4 || tabIndex === 5|| tabIndex === 6">
        <button type="button" class="btn btn-outline-primary left_icon_btn gtmAddPageLogo" (click)="addPage()"
          *ngIf="!isPage3Created">
          <img src="assets/images/plus_square_outline.svg" alt="add page" />
          <span i18n="@@logo-content.logo-content-groups.add-page">Add Page</span>
        </button>
        <button type="button" class="btn btn-primary gtmSaveLogoContGrp"
          (click)="pageError.get(1)||pageError.get(2)||pageError.get(3)?openPopupError(errorPopup):updateLCG()">
          {{buttonName}}
        </button>
      </div>
    </div>
    <iposcen-showon-device #showModal (show)="showOnDevice()" (closePopup)="closeShowOnDevice()">
    </iposcen-showon-device>
    <iposcen-apply-changes-to-devices #applyModal (apply)="applyToDevice(true)" (closePopup)="applyToDevice(false)">
    </iposcen-apply-changes-to-devices>
  </section>
</div>
<!-- //popup page delete  -->
<ng-template #deletePageModal let-modal>
  <div id="confrmPopUp" class="card confirmPopup">
    <div id="modalHeader" class="modal-header">
      <div id="modalCloseIcon" (click)="modal.close()" class="close-icon">
        <img src="../../../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="modalBody" class="modal-body popup-body">
      <div id="modalBodyTitle">
        <h2 class="mt-3">
          <span i18n="@@create-partner-content.delete-modal.delete-page?">Delete Page?</span>
        </h2>
        <div id="modalBodyText" class="card-desc">
          <span i18n="@@create-partner-content.delete-modal.remove-permanently">This content will be removed
            permanently.</span>
        </div>
      </div>
    </div>
    <div id="modalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close()" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@create-partner-content.delete-modal.cancel">Cancel</span>
      </button>
      <button type="button" class="btn btn-primary btn-confirm" (click)="modal.close();deletePages(whichPageDelete)">
        <span i18n="@@create-partner-content.delete-modal.delete-page">Delete Page</span>
      </button>
    </div>
  </div>
</ng-template>
<ng-template #errorPopup let-modal>
  <div id="confirmPopupCard" class="card confirmPopup">
    <div id="confirmModalHeader" class="modal-header">
      <div id="modalClose" (click)="modal.close()" class="close-icon">
        <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="confirmPopupModalBody" class="modal-body popup-body">
      <div id="confirmModalDesc">
        <div id="confirmDesc" class="card-desc">
          <span *ngIf='pageError.get(1) && !pageError.get(2) && !pageError.get(3)'>{{errorMessageText}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(2)  && !pageError.get(3)'>{{errorMessageText1}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(3)  && !pageError.get(2)'>{{errorMessageText2}}</span>
          <span *ngIf='pageError.get(2) && !pageError.get(3) && !pageError.get(1)'>{{errorMessageText3}}</span>
          <span *ngIf='pageError.get(2) && pageError.get(3)  && !pageError.get(1)'>{{errorMessageText4}}</span>
          <span *ngIf='pageError.get(3) && !pageError.get(1) && !pageError.get(2)'>{{errorMessageText5}}</span>
          <span *ngIf='pageError.get(3) && pageError.get(1) && pageError.get(2)'>{{errorMessageText6}}</span>
        </div>
      </div>
    </div>
    <div id="modalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close();goToErrorPage()" class="btn btn-primary btn-confirm">
        <span>{{buttonLable}}</span>
      </button>
    </div>
  </div>
</ng-template>